import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/index/content-img1.png';
import _imports_1 from '@/assets/img/index/content-img2.png';
import _imports_2 from '@/assets/img/index/content-img3.png';
const _withScopeId = n => (_pushScopeId("data-v-5041b4de"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "让软件更安全，让安全更智能", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "重新定义软件安全格局，用心提供专业服务支持", -1));
const _hoisted_3 = {
  class: "navbar-box"
};
const _hoisted_4 = {
  alt: "无垠模糊测试智能体"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "无垠模糊测试智能体", -1));
const _hoisted_6 = {
  alt: "无垠协议模糊测试智能体"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "无垠协议模糊测试智能体", -1));
const _hoisted_8 = {
  alt: "开发安全服务"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开发安全咨询服务", -1));
const _hoisted_10 = {
  class: "navbar-content-item-box"
};
const _hoisted_11 = {
  class: "right-img-box"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title-centent"
}, "无垠模糊测试智能体", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips-centent"
}, " 以代码二进制为测试对象，借助大模型能力可实现测试驱动自动生成，测试用例智能评估，风险优先级评定和辅助生成修复代码，提升发现软件漏洞的能力，简化漏洞修复过程。 ", -1));
const _hoisted_14 = {
  class: "features-box"
};
const _hoisted_15 = {
  class: "features-item"
};
const _hoisted_16 = {
  class: "features-icon icon1"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "漏洞定位"), /*#__PURE__*/_createElementVNode("p", null, "漏洞定位精确至代码行，确保问题可复现")], -1));
const _hoisted_18 = {
  class: "features-item"
};
const _hoisted_19 = {
  class: "features-icon icon2"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "智能优化"), /*#__PURE__*/_createElementVNode("p", null, " 采用遗传变异算法，通过覆盖率引导自动优化测试策略 ")], -1));
const _hoisted_21 = {
  class: "features-item"
};
const _hoisted_22 = {
  class: "features-icon icon3"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "定制解决方案"), /*#__PURE__*/_createElementVNode("p", null, "行业经验结合测试反馈，形成用户专属解决方案库")], -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title-centent"
}, "无垠协议模糊测试智能体", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips-centent"
}, " 通过向被测协议对象提供非预期的输入并监视异常结果，自动化检测系统缺陷并验证协议功能，并提出高质量修复建议。从源头助力企业实现自动化安全检测，提升协议应用的安全性与健壮性。 ", -1));
const _hoisted_26 = {
  class: "features-box"
};
const _hoisted_27 = {
  class: "features-item"
};
const _hoisted_28 = {
  class: "features-icon icon4"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "智能"), /*#__PURE__*/_createElementVNode("p", null, "智能生成测试用例，测试流程全托管")], -1));
const _hoisted_30 = {
  class: "features-item"
};
const _hoisted_31 = {
  class: "features-icon icon5"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "无侵入"), /*#__PURE__*/_createElementVNode("p", null, "无损伤，不接触源码或程序结构")], -1));
const _hoisted_33 = {
  class: "features-item"
};
const _hoisted_34 = {
  class: "features-icon icon6"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "精准"), /*#__PURE__*/_createElementVNode("p", null, "所发现异常均发生在实际生产环境，确保零误报")], -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title-centent"
}, "开发安全咨询服务", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips-centent"
}, " 覆盖软件开发全生命周期（需求、设计、编码、测试、部署等开发阶段），帮助企业搭建流程、制度、规范等体系建设，将安全能力融入到软件开发生命周期的每一个阶段。 ", -1));
const _hoisted_38 = {
  class: "features-box"
};
const _hoisted_39 = {
  class: "features-item"
};
const _hoisted_40 = {
  class: "features-icon icon7"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "研发安全流程治理")], -1));
const _hoisted_42 = {
  class: "features-item"
};
const _hoisted_43 = {
  class: "features-icon icon8"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "研发安全成熟度品评估")], -1));
const _hoisted_45 = {
  class: "features-item"
};
const _hoisted_46 = {
  class: "features-icon icon9"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "features-text"
}, [/*#__PURE__*/_createElementVNode("h5", null, "研发安全流程和工具化体系建设")], -1));
const _hoisted_48 = {
  class: "btn-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_buttom_com = _resolveComponent("buttom-com");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'productNavbar-box active' : 'productNavbar-box')
  }, [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'navbar-item active-item' : 'navbar-item'),
    onMouseenter: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.changeActive(1), ["stop"])),
    onMouseleave: _cache[1] || (_cache[1] = _withModifiers((...args) => _ctx.outFunc && _ctx.outFunc(...args), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icon1.png')]]), _hoisted_5], 34), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 2 ? 'navbar-item active-item' : 'navbar-item'),
    onMouseenter: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.changeActive(2), ["stop"])),
    onMouseleave: _cache[3] || (_cache[3] = _withModifiers((...args) => _ctx.outFunc && _ctx.outFunc(...args), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icon2.png')]]), _hoisted_7], 34), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 3 ? 'navbar-item active-item' : 'navbar-item'),
    onMouseenter: _cache[4] || (_cache[4] = _withModifiers($event => _ctx.changeActive(3), ["stop"])),
    onMouseleave: _cache[5] || (_cache[5] = _withModifiers((...args) => _ctx.outFunc && _ctx.outFunc(...args), ["stop"]))
  }, [_withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icon3.png')]]), _hoisted_9], 34)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
    class: _normalizeClass(_ctx.active == 1 ? 'active right-img' : 'right-img'),
    src: _imports_0,
    alt: "无垠模糊测试智能体"
  }, null, 2), _createElementVNode("img", {
    class: _normalizeClass(_ctx.active == 2 ? 'active right-img' : 'right-img'),
    src: _imports_1,
    alt: "无垠协议模糊测试智能体"
  }, null, 2), _createElementVNode("img", {
    class: _normalizeClass(_ctx.active == 3 ? 'active right-img' : 'right-img'),
    src: _imports_2,
    alt: "开发安全服务"
  }, null, 2)]), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 1 ? 'left-content active' : 'left-content')
  }, [_hoisted_12, _hoisted_13, _createElementVNode("ul", _hoisted_14, [_createElementVNode("li", _hoisted_15, [_withDirectives(_createElementVNode("i", _hoisted_16, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_17]), _createElementVNode("li", _hoisted_18, [_withDirectives(_createElementVNode("i", _hoisted_19, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_20]), _createElementVNode("li", _hoisted_21, [_withDirectives(_createElementVNode("i", _hoisted_22, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_23])])], 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 2 ? 'left-content active' : 'left-content')
  }, [_hoisted_24, _hoisted_25, _createElementVNode("ul", _hoisted_26, [_createElementVNode("li", _hoisted_27, [_withDirectives(_createElementVNode("i", _hoisted_28, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_29]), _createElementVNode("li", _hoisted_30, [_withDirectives(_createElementVNode("i", _hoisted_31, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_32]), _createElementVNode("li", _hoisted_33, [_withDirectives(_createElementVNode("i", _hoisted_34, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_35])])], 2), _createElementVNode("div", {
    class: _normalizeClass(_ctx.active == 3 ? 'left-content active' : 'left-content')
  }, [_hoisted_36, _hoisted_37, _createElementVNode("ul", _hoisted_38, [_createElementVNode("li", _hoisted_39, [_withDirectives(_createElementVNode("i", _hoisted_40, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_41]), _createElementVNode("li", _hoisted_42, [_withDirectives(_createElementVNode("i", _hoisted_43, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_44]), _createElementVNode("li", _hoisted_45, [_withDirectives(_createElementVNode("i", _hoisted_46, null, 512), [[_directive_lazy, require('@/assets/img/index/navbar-icons.png'), "background-image"]]), _hoisted_47])])], 2)]), _createElementVNode("div", _hoisted_48, [_createVNode(_component_buttom_com, {
    btnName: "了解更多",
    onClick: _cache[6] || (_cache[6] = $event => _ctx.jumpPage('/bookDemoPage.html')),
    filling: true
  })])], 2);
}